import { Swiper, SwiperSlide } from 'swiper/react';
import EcoSpace from 'eco-design/base/eco-space';
import { useState, useRef } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import Tabs from '../Tabs';
import CommonTitle from '../CommonTitle';
import AnimatedSection from '../AnimatedSection';
import styles from './index.module.scss';
import TriggleIcon from './TriggleIcon';
import { useLang } from '@/app/utils/useLang';
import getLocal from 'eco-design-reliance/getLocal';

const Output: React.FC = () => {
    const { t } = useLang('Output');
    const swiperRef = useRef<any>(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const { locale = 'us' } = getLocal();
    const isEu = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale)

    const tabs = [
        {
            tabLabel: t('tab1'),
            tabValue: 'a1',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758199047694-ctcabr-compressed-Kitchen.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758201505003-0shd5g-compressed-Kitchen.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758201505003-0shd5g-compressed-Kitchen.jpg',
            things: [t('tab1_thing1'), t('tab1_thing2'), t('tab1_thing3'), t('tab1_thing4')],
        },
        {
            tabLabel: t('tab2'),
            tabValue: 'a2',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758199071606-pu6xw5-compressed-Living%20Room.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758199134241-yp2kiv-compressed-Living%20Room.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758199134241-yp2kiv-compressed-Living%20Room.jpg',
            things: [t('tab2_thing1'), t('tab2_thing2'), t('tab2_thing3'), t('tab2_thing4')],
        },
        {
            tabLabel: t('tab3'),
            tabValue: 'a3',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758200392610-k7fu3j-compressed-Outdoors.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758199149051-0omkxq-compressed-Outdoors.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758199149051-0omkxq-compressed-Outdoors.jpg',
            things: [t('tab3_thing1'), t('tab3_thing2'), t('tab3_thing3'), t('tab3_thing4')],
        },
        {
            tabLabel: t('tab4'),
            tabValue: 'a4',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758199097609-gdykcc-compressed-Office.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758199162741-uynaxn-compressed-Office.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758199162741-uynaxn-compressed-Office.jpg',
            things: [t('tab4_thing1'), t('tab4_thing2'), t('tab4_thing3'), t('tab4_thing4')],
        },
    ];

    const onChange = (item: any, index: number) => {
        setActiveIndex(index);
        swiperRef.current.slideTo(index);
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);

        // tab 滚动
        const targetTabItem = document.querySelectorAll('.output-tabs .eco-tab-item')[index];
        const tabsEle = document.querySelector('.output-tabs .eco-tab-items-move');

        if (!targetTabItem || !tabsEle) return;
        const parentRect = targetTabItem.getBoundingClientRect();

        const elemRect = tabsEle.getBoundingClientRect();

        let scrollLeft: number;

        const padding = window.innerWidth > 1024 ? 0 : window.innerWidth > 768 ? 48 : 24;
        // 如果是第一个item，滚动到最左边
        if (index === 0) {
            scrollLeft = elemRect.left - parentRect.left - padding;
        }
        // 如果是最后一个item，滚动到最右边
        else if (index === tabs.length - 1) {
            scrollLeft = elemRect.right - parentRect.right + padding;
        }
        // 其他情况居中显示
        else {
            scrollLeft = elemRect.left - parentRect.left - parentRect.width / 2 + elemRect.width / 2;
        }

        parent.scrollBy({
            left: scrollLeft,
            behavior: 'smooth',
        });
    };

    return (
        <div className={`${styles.Output} GtmModuleData-section`} data-section-id="d3c-Output" id="Output">
            {!isEu && <EcoSpace />}
            <CommonTitle
                title={t('title')}
                desc={t.rich('desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
            />
            <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                <div className="swiper-output d3m-layout">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={1}
                        spaceBetween={12}
                        initialSlide={0}
                        onSlideChange={handleSlideChange}
                    >
                        {tabs.map((item, index) => (
                            <SwiperSlide key={index} className={`list-item list-item-${index + 1}`}>
                                <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy={true} />
                                <div className="things">
                                    {item.things.map((thing, _index) => (
                                        <div key={_index} className={`thing thing-${index + 1}_${_index + 1}`}>
                                            {thing}
                                            <TriggleIcon className="triggle-icon" />
                                        </div>
                                    ))}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </AnimatedSection>

            <div className="d3m-tabs">
                <Tabs tabs={tabs} activeIndex={activeIndex} onChange={onChange} />
            </div>
        </div>
    );
};

export default Output;
